import { render, staticRenderFns } from "./CommComTabs.vue?vue&type=template&id=78c47a9e&"
import script from "./CommComTabs.vue?vue&type=script&lang=js&"
export * from "./CommComTabs.vue?vue&type=script&lang=js&"
import style0 from "./CommComTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports